import { ToastTypeEnum } from "context/toastContext";

interface WebViewFileProps {
  url: string;
}

export const webViewFile = ({ url }: WebViewFileProps) => {
  const a = document.createElement("a");
  a.href = url;
  a.style.display = "none";
  document.body.appendChild(a);
  a.target = "_blank";
  a.click();
  a.remove();
};

interface DownloadFileProps {
  blob: Blob | MediaSource;
  filename?: string;
}

export const downloadFile = async ({ blob, filename }: DownloadFileProps): Promise<void> => {
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  if (filename) a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
};

type FetchParameters = Parameters<typeof fetch>;

interface FetchFileProps {
  url: FetchParameters[0];
  init?: FetchParameters[1];
  filename?: string;
  addToast: (arg: { text: string; type: ToastTypeEnum }) => void;
  onSuccess?: () => void;
}

export const fetchFile = async ({ url, init, filename, addToast, onSuccess }: FetchFileProps): Promise<void> => {
  return fetch(url, init)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error();
      }

      return response.blob();
    })
    .then((blob) => {
      downloadFile({ blob, filename });
      if (onSuccess) onSuccess();
    })
    .catch(() => {
      addToast({ text: "Ошибка при скачивании файла", type: ToastTypeEnum.ERROR });
    });
};
